export function authHeader() {
    // return authorization header with jwt token

    // 1. redux - store에서 user정보를 호출
    // 새로고침 시 store의 정보가 초기화 되는 문제점 발생
    // const state = store.getState();
    // let authentication = state.authentication ? state.authentication : {};
    // let user = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : authentication.user ? authentication.user : "";
    
    // 2. localStorage, sessionStorage에서 user정보를 호출
    let user = "";
    if (JSON.parse(localStorage.getItem('user'))) user = JSON.parse(localStorage.getItem('user'));
    else if (JSON.parse(sessionStorage.getItem('user'))) user = JSON.parse(sessionStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}